import React from 'react';
import { Col, Row } from 'react-bootstrap';
import SharedActions from '../sharedActions';

//shared tooltip component
const SingleNftToMint = ({ item, mint }) => {
  return (
    <div className="content">
      <div className="latest-games-items mb-30">
        <div className="latest-games-thumb single-nft-mint">
          <a>
            <img
              src={item.image}
              alt=""
            />
          </a>
          <div className="content-overlay"></div>
        </div>
        <div className="content-details fadeIn-bottom">
          <p className="content-text">{item.description}</p>
        </div>
        <div className="latest-games-content">
          <div className="lg-tag">
            <a>{item.type}</a>
          </div>
          <Row className="d-flex align-items-center mb-2">
            <Col>
              <h4 className="mb-0">{item.name}</h4>
            </Col>
            <Col className="float-right col-auto text-right">
              <SharedActions
                tweetTitle={`${item.name}`}
                tweetLink={`${window.location.origin}/#/shop`}
                className='float-right'
              />
            </Col>
          </Row>
          <p>
            Buy fee : <span>{item.price}</span>{' '}
            <a
              onClick={mint}
              className="btn btn-style-two float-right"
            >
              Buy
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SingleNftToMint;
